import { IAppState } from '../../redux';
import { selectBetPosition } from './selectBetPosition';

export function selectBetPageFullConcurrency(state: IAppState): number | null {
  const betPosition = selectBetPosition(state);

  if (!betPosition) {
    return null;
  }

  return betPosition.betPageFullConcurrency;
}
